import { useState, useEffect, useCallback } from 'react'

import axios from 'axios'

import isAxiosCancelOrNetworkError from 'Utils/isAxiosCancelOrNetworkError'

function useEarningsOverview(initialScope) {
  const [data, setData] = useState({})
  const [earningsScope, setEarningsScope] = useState(initialScope)
  const [isDataFetched, setIsDataFetched] = useState(false)
  const [axiosSource] = useState(axios.CancelToken.source())

  const onFetchSuccess = useCallback((response) => {
    setData(response.data)
    setIsDataFetched(true)
  }, [])

  const fetchData = useCallback(
    (monthsCount) => {
      return axios
        .get('/api/internal/seller_dashboard/profile', {
          params: { months_count: monthsCount },
          cancelToken: axiosSource.token,
        })
        .then((response) => onFetchSuccess(response))
        .catch((error) => {
          if (!isAxiosCancelOrNetworkError(error)) {
            if (window.Sentry) window.Sentry.captureException(error, { extra: window.location })
            App.events.publish(
              'app:notification:flash:error',
              'Unable to load earnings data. Please reload the page.'
            )
          }
        })
    },
    [axiosSource, onFetchSuccess]
  )

  const onSortChange = useCallback(
    (dataResult) => {
      setEarningsScope(dataResult.value)
      setIsDataFetched(false)
      fetchData(dataResult.value)
    },
    [fetchData]
  )

  useEffect(() => {
    fetchData(earningsScope)
    return () => {
      axiosSource.cancel()
    }
  }, [])

  return {
    data,
    earningsScope,
    isDataFetched,
    onSortChange,
  }
}

export default useEarningsOverview
